<forge-avatar *ngIf="hasPhoto" [imageUrl]="photoUrl">
</forge-avatar>

<ng-container *ngIf="!hasPhoto">
    <ng-container *ngIf="hasEmblemText && !useAvatarIcon">
        <forge-avatar *ngIf="useAppIcon" [src]="appIconUrl" [ngClass]="emblemClass" [attr.telemetry]="item.EmblemText">
        </forge-avatar>

        <forge-avatar *ngIf="!useAppIcon" [text]="item.EmblemText" [ngStyle]="emblemTextStyles" [attr.telemetry]="item.EmblemText" auto-color="true">
        </forge-avatar>
    </ng-container>

    <forge-avatar *ngIf="useAvatarIcon" [ngStyle]="emblemTextStyles" [attr.telemetry]="item.EmblemText">
        <mat-icon class="avatar-icon" [fontIcon]="item.AvatarIcon"></mat-icon>
    </forge-avatar>

    <forge-tooltip placement="bottom">
        {{emblemTooltip}}
    </forge-tooltip>
</ng-container>
